/**
 * Server (categoryMiddleware) có slug của CẢ HAI ngôn ngữ; client chỉ có tên danh mục
 * của ngôn ngữ đang xem (`category.nameLocal`) nên KHÔNG tự dựng được URL ngôn ngữ kia.
 * Tự dựng là nguồn của lỗi đo được trên prod: trên `?lang=en`, canonical client ra
 * `/veggies-fruit-c122` (URL phục vụ tiếng Việt) và hreflang="vi" cũng trỏ vào slug EN.
 *
 * Nên chụp lại thẻ server inject ngay lúc boot — trước khi helmet-async xoá mọi thẻ
 * `[data-rh]` mà nó quản lý. Phải import từ `app/app.tsx` để chạy trước lượt render đầu.
 */
export interface SeoServerLinks {
  href: string;
  canonical: string;
  vi: string;
  en: string;
  xDefault: string;
}

const readHref = (selector: string): string =>
  (typeof document === 'undefined' ? null : document.querySelector(selector))?.getAttribute('href') ?? '';

const snapshot: SeoServerLinks | null = (() => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return null;
  const canonical = readHref('link[rel="canonical"][data-rh]');
  const vi = readHref('link[rel="alternate"][hreflang="vi"][data-rh]');
  const en = readHref('link[rel="alternate"][hreflang="en"][data-rh]');
  if (!canonical || !vi || !en) return null;
  return {
    href: window.location.href,
    canonical: canonical,
    vi: vi,
    en: en,
    xDefault: readHref('link[rel="alternate"][hreflang="x-default"][data-rh]') || vi,
  };
})();

/**
 * Chỉ trả snapshot khi URL chưa đổi. Sau điều hướng SPA nó thuộc trang trước, và crawler
 * thì luôn tải mới nên vẫn nhận đúng giá trị của server.
 */
export const getSeoServerLinks = (): SeoServerLinks | null =>
  snapshot && typeof window !== 'undefined' && snapshot.href === window.location.href ? snapshot : null;

export default getSeoServerLinks;
